import { render, staticRenderFns } from "./RolesDetails.vue?vue&type=template&id=1c5c49ec"
import script from "./RolesDetails.vue?vue&type=script&lang=js"
export * from "./RolesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports